module.exports = __webpack_public_path__ + "static/one-billion-hungry-3fd20efb03de8a0297520fd181393b41.jpg";